import React, { useMemo } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { FormattedMessage } from "react-intl";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import { buttonDisabled, requestToAddFollowup, showFollowUps, billingReasonMandatory } from "../../redux/task/taskActions";
import { duplicateCheckPopup } from "../../redux/followUps/followUpsActions";
import { Form } from "./form";
import PageHeader from "../header/pageHeader";
import useActivityQuestions from "../activityQuestions/hooks/useActivityQuestions";

export const useActionStyles = makeStyles((theme) => ({
    paper: {
        border: "none",
        //padding: '0px 16px',
        backgroundColor: theme.palette.background.paper,
        maxHeight: "100%",
        overflow: "auto",
    },
    sectionFooter: {
        background: "white",
        display: "flex",
        marginTop: "4px",
        bottom: "0",
        height: "70px",
        position: "fixed",
        width: "100%",
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.14), 0px 4px 5px rgba(0, 0, 0, 0.12), 0px 1px 10px rgba(0, 0, 0, 0.2)",
    },
    submitBtn: {
        marginLeft: "auto",
        marginRight: "30px",
        color: "var(--blue-bell)",
        textTransform: "none",
    },
    sectionHeader: {
        fontFamily: "Arial",
        fontSize: "16px",
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "22px",
        letter: "-0.5px",
        padding: "11px 0px 11px 16px",

        borderBottom: "1px solid #CCCCCC",
    },
    sectionFooter: {
        background: "white",
        display: "flex",
        marginTop: "4px",
        bottom: "0",
        height: "70px",
        position: "fixed",
        width: "100%",
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.14), 0px 4px 5px rgba(0, 0, 0, 0.12), 0px 1px 10px rgba(0, 0, 0, 0.2)",
    },
    list: {
        overflowY: "auto",
        padding: "0px",
    },
    submitBtn: {
        marginLeft: "auto",
        marginRight: "30px",
        color: "var(--blue-bell)",
        textTransform: "none",
    },
    listItem: {
        margin: "5px",
        border: "1px solid black",
        borderRadius: "5px",
    },
    listItemChecked: {
        margin: "5px",
        border: "1px solid blue",
        borderRadius: "5px",
    },
    checkedIcon: {
        borderRadius: "50px",
        backgroundColor: "#137cbd",
        display: "block",
        width: "16px",
        height: "16px",
        backgroundImage:
            "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
        content: "",
    },
    picker: {
        height: "245px",
        overflowY: "scroll",
    },
}));

const WorkOrderAction = (props) => {
    const history = useHistory();
    const classes = useActionStyles();
    const { hasAllMandatoryQuestionsAnswered } = useActivityQuestions();

    var disabled = props.filesToUpload && props.filesToUpload.length > 0 && props.filesToUpload.some((file) => file.fileName.trim() === "");
    if (props.incomplete) disabled = props.error || disabled;
    if (props.followUps) disabled = props.data.FirstfollowupReason == null || props.data.dueDate == null || disabled;
    const allQuestionsAnswered = useMemo(() => {
        const hasFollowupsWithQuestions = props.data?.followUps?.filter((followup) => followup.hasActivityQuestions) ?? [];
        const hasAllQuestionsAnswered =
            hasFollowupsWithQuestions.length > 0
                ? hasFollowupsWithQuestions.every((followup) => hasAllMandatoryQuestionsAnswered(followup.uuid))
                : true;
        return hasAllQuestionsAnswered;
    }, [props.data?.followUps, hasAllMandatoryQuestionsAnswered]);
    if (!allQuestionsAnswered) {
        disabled = true;
    }

    const onBack = () => {
        history.goBack();
        props.buttonDisabled(false);
        props.billingReasonMandatory(false);
        props.requestToAddFollowup(false);
        props.showFollowUps(true);
        props.duplicateCheckPopup(false);
    };
    return (
        <>
            <PageHeader title={props.title} onBack={onBack} />
            <Form value={props.data}>
                {props.children}
                <div className={classes.sectionFooter}>
                    <Button
                        className={classes.submitBtn}
                        onClick={props.onSubmit}
                        disabled={disabled || props.isButtonDisabled || props.isBillingReasonMandatory}>
                        <FormattedMessage id="work-order-action.submit-caption" defaultMessage="Submit >" description="submit work order action" />
                    </Button>
                </div>
            </Form>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        error:
            state.workorder.incomplete.incompleteReason ||
            state.workorder.incomplete.incompleteSubReason ||
            state.workorder.incomplete.additionalComments ||
            state.workorder.incomplete.newDueDate,
        filesToUpload: state.attachments.filesToUpload,
        isButtonDisabled: state.tasks.isButtonDisabled,
        isBillingReasonMandatory: state.tasks.isBillingReasonMandatory,
    };
};
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            buttonDisabled,
            requestToAddFollowup,
            showFollowUps,
            duplicateCheckPopup,
            billingReasonMandatory,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(WorkOrderAction);
